import type { WrapProps } from '@leafwell/components';
import type { Page } from 'types/page';
import React from 'react';
import Image from 'next/image';
import { Heading, Paragraph, Wrap } from '@leafwell/components';
import HeadingBody from 'components/heading-body';
import SignupForm from 'components/signup-form';
import WysiwygContent from './wysiwyg-content';

const HeroCannabisGuidance: React.FC<
  Partial<Pick<WrapProps, 'className' | 'spacer'>> &
    Pick<Page['acf'], 'hero' | 'pageType' | 'redirectCannabisCounseling'>
> = ({
  hero,
  pageType = 'cannabis_counseling',
  redirectCannabisCounseling,
  className = '',
  spacer = true,
}) => {
  return (
    <Wrap
      className={[
        'grid lg:grid-cols-2 gap-y-32 items-start gap-x-10',
        className,
      ].join(' ')}
      spacer={spacer}
      tagName="header"
    >
      <div className="grid gap-y-6">
        <HeadingBody
          level="5"
          tagName="p"
          title={hero.subTitle}
          className="hidden lg:block"
        />
        <Heading
          level="1"
          className="font-sans my-reset prose !text-3xl xl:!text-7xl xl:-mt-3"
        >
          {hero.title}
        </Heading>
        {hero.description && <WysiwygContent content={hero.description} />}
        {hero.badges?.length > 0 && (
          <div className="grid xl:flex gap-x-8 xl:mt-32">
            {hero.badges.map(({ label, icon }, idx) => (
              <article
                key={`badge-${idx}`}
                className="flex gap-x-2 items-center justify-start mt-2 xl:flex-col xl:border xl:rounded-2xl xl:border-white xl:bg-white xl:p-6 xl:gap-6 xl:w-48 xl:justify-items-center xl:mt-0"
              >
                {icon && (
                  <Image
                    src={icon.src}
                    className="w-5 xl:w-auto"
                    alt={icon.alt}
                    width={icon.width}
                    height={icon.height}
                  />
                )}
                <Paragraph className="text-center text-sm xl:text-lg">
                  {label}
                </Paragraph>
              </article>
            ))}
          </div>
        )}
      </div>
      <div className="w-full max-w-md justify-self-center lg:justify-self-end">
        <SignupForm
          pageType={pageType}
          redirectMedicalCard={false}
          redirectCannabisCounseling={redirectCannabisCounseling}
          formSubmitText={hero.formSubmitText}
        />
      </div>
    </Wrap>
  );
};

export default HeroCannabisGuidance;
